import { Component, Host, h, Prop, Element, Listen } from '@stencil/core';
import { VdsContentBaseProperties } from '../vds-content-base/vds-content-base.interface';

@Component({
  tag: 'vds-content-media',
  styleUrl: 'vds-content-media.scss',
  shadow: true,
})
export class VdsContentMedia implements VdsContentBaseProperties {

  @Element() el!: HTMLElement;

  /**
   * Headline for the Content Modules
   * Mandatory: no
   * Max Chars: 50
   */
  @Prop() headline = '';

  /**
   * Subline for the Content Module
   * Mandatory: no
   * Max Chars: 150
   */
  @Prop() subline = '';

  /**
   * Controls wether or not the downloads should be displayed
   */
  @Prop() showDownloads = false;

  /**
   * Controls wether or not the call-to-action buttons should be displayed
   */
  @Prop() showCtas = false;

  @Listen('resize', { target: 'window' })
  handleResize() {
    this.setupSlides();
  }

  render() {
    const { headline, subline, showDownloads } = this;

    return (
      <Host>
        <vds-content-base headline={headline} subline={subline} show-downloads={showDownloads}>

          <div slot="copy-above">
            <slot name="copy-above"></slot>
          </div>

          <div slot="media" class="w-full overflow-hidden">
            <slot name="media"></slot>
            <slot name="pagination"></slot>
          </div>

          <div slot="copy-below">
            <slot name="copy-below"></slot>
          </div>

          { showDownloads && (
            <div slot="downloads">
              <slot name="downloads"></slot>
            </div>
          )}
        </vds-content-base>
        {
          this.showCtas &&
          <div class="flex flex-wrap flex-row justify-start gap-y-3 gap-x-6 mt-6">
            <slot name="ctas"></slot>
          </div>
        }
      </Host>
    );
  }

  componentDidRender(): void {
    this.setupSlides();
  }

  private setupSlides(): void {
    const largeMediaQuery = `(min-width: ${getComputedStyle(document.documentElement).getPropertyValue('--vt-breakpoint-lg').trim()})`;
    const slidesEl = this.el.querySelector('vds-slides');

    if(window.matchMedia(largeMediaQuery).matches) {
      slidesEl?.setSpaceBetween(50);
    }
    else {
      slidesEl?.setSpaceBetween(30);
    }
  }

}
